import { ReactNode } from 'react'

import { Box, Button, Tag, TagColor } from '@factorialco/deprecated-design-system'

export const SectionWithStatus: React.FC<{
  tagColor: TagColor
  tagLabel: string
  count?: number
  children: ReactNode
  action?: {
    label: string
    onClick: () => void
  }
}> = ({ tagColor, tagLabel, count, children, action }) => {
  return (
    <Box gap="s16">
      <Box flexDirection="row">
        <Box flexGrow>
          <Tag type={tagColor} inline>
            {tagLabel}
            {count !== undefined && <> ({count})</>}
          </Tag>
        </Box>
        {action && (
          <Box>
            <Button onClick={action.onClick}>{action.label}</Button>
          </Box>
        )}
      </Box>
      <Box>{children}</Box>
    </Box>
  )
}
